/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { gateWayManagementAPI } from "./services/api";
import { buildingsManagementAPI } from "./services/rbm-api";
import { fileServeApi } from "./services/file-service-api/fileServeApi";

import rootReducer from "./reducers";
import { remoteConnectAPI } from "./services/remote-connect-api";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(gateWayManagementAPI.middleware)
      .concat(fileServeApi.middleware)
      .concat(buildingsManagementAPI.middleware)
      .concat(remoteConnectAPI.middleware),
});

// Optional: Set up listeners for cache invalidation and refetching
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
